import React, { useState } from 'react'
import { ContractorDataDto } from '../../api/estimates/types/model'
import { Icon } from '../../shared/ui/Icon'
import { colors } from '../../shared/ui/colors'
import { ContractDetails } from './ContractDetails'
import {
  TableContainer,
  TableRow,
  TableRowWrapper,
  CompanyCell,
  CompanyName,
  CompanyInn,
  DataCell,
  DataValue,
  DataBreakdown,
  BreakdownItem,
  ArrowIcon,
  CompanyDetails,
  DataLabel
} from './EstimateTable.styles'

interface EstimateTableProps {
  contractors: ContractorDataDto[]
}

const formatAmount = (amount: number): string => {
  return (
    new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount) + ' ₽'
  )
}

export const EstimateTable: React.FC<EstimateTableProps> = ({
  contractors
}) => {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set())

  const toggleRow = (contractorGuid: string) => {
    setExpandedRows(prev => {
      const newSet = new Set(prev)
      if (newSet.has(contractorGuid)) {
        newSet.delete(contractorGuid)
      } else {
        newSet.add(contractorGuid)
      }
      return newSet
    })
  }

  const contractorsWithContracts = contractors.filter(
    contractor => contractor.contracts && contractor.contracts.length > 0
  )

  return (
    <TableContainer>
      {contractorsWithContracts.map(contractor => {
        const isExpanded = expandedRows.has(contractor.guid)
        return (
          <TableRowWrapper key={contractor.guid}>
            <TableRow onClick={() => toggleRow(contractor.guid)} $isClickable>
              <CompanyCell>
                <Icon type="organization" size={18} className="bg-gray" />
                <CompanyDetails>
                  <CompanyName>{contractor.name || 'Не указано'}</CompanyName>
                  {contractor.inn && (
                    <CompanyInn>ИНН: {contractor.inn}</CompanyInn>
                  )}
                </CompanyDetails>
              </CompanyCell>

              <DataCell>
                <DataLabel>
                  <Icon type="document" size={11} color="#155DFC" />
                  <span>Подписано договоров</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contractor.totalByContracts.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="check-document" size={11} color="#00A63E" />
                  <span>В процессе согласования</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contractor.inApprovalProcess.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="check-document" size={11} color="#9810FA" />
                  <span>Итого по актам</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contractor.totalByActs.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="dollar" size={11} color="#F54900" />
                  <span>Итого оплат</span>
                </DataLabel>
                <DataValue>{formatAmount(0)}</DataValue>
                <DataBreakdown>
                  <BreakdownItem>
                    Распред. письма: {formatAmount(0)}
                  </BreakdownItem>
                </DataBreakdown>
                <ArrowIcon>
                  <Icon
                    type={isExpanded ? 'chevron_up' : 'chevron_down'}
                    size={20}
                    color={colors.gray600}
                  />
                </ArrowIcon>
              </DataCell>
            </TableRow>
            {isExpanded &&
              contractor.contracts &&
              contractor.contracts.length > 0 && (
                <ContractDetails contracts={contractor.contracts} />
              )}
          </TableRowWrapper>
        )
      })}
    </TableContainer>
  )
}
